import {Route, Routes} from 'react-router-dom';
import {InstrumentThemes} from './index';
import {ThemeForm} from './ThemeForm';

/** /dashboard/instrument-themes/* */
const InstrumentThemeRoutes = () => (
  <Routes>
    <Route path="/" element={<InstrumentThemes />} />
    <Route path="/new" element={<ThemeForm />} />
    <Route path="/update/:id" element={<ThemeForm />} />
  </Routes>
);

export default InstrumentThemeRoutes;
